import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Cancel } from "@mui/icons-material"; // MUI Cancel (Cross) Icon
import Navbar from "../../components/Navbar/Navbar";
import Footer from "../../components/Footer/Footer";

const LandlordPaymentFailView = () => {
  const location = useLocation();
  const navigate = useNavigate();

  // Extract rToken from URL
  const params = new URLSearchParams(location.search);
  const rToken = params.get("rToken");

  const handleRetry = () => {
    // if (rToken) {
    //   navigate(`/Landlord/retry-payment?rToken=${rToken}`);
    // } else {
      navigate("/Landlord/payment");
    // }
  };

  const handleContactUs = () => {
    navigate("/contact-us");
  };

  return (
    <div>
      <Navbar />
      <div className="container flex flex-col items-center justify-center min-h-screen text-center">
        <div className="bg-white p-6 rounded-lg shadow-lg max-w-md w-full">
          <div className="flex justify-center mb-4">
            <Cancel fontSize="large" color="error" sx={{ fontSize: 60 }} /> 
          </div>
          <h2 className="text-2xl font-semibold text-gray-800">
            Payment Failed!
          </h2>
          <p className="text-gray-600 mt-2">
            There was an error processing your payment. Please try again or
            contact us for assistance.
          </p>
          <div className="mt-6 flex flex-col gap-3">
            <button
              onClick={handleRetry}
              className="bg-blue-600 text-white px-4 py-2 rounded-lg w-full hover:bg-blue-700"
            >
              Try Again
            </button>
            <button
              onClick={handleContactUs}
              className="bg-gray-500 text-white px-4 py-2 rounded-lg w-full hover:bg-gray-600"
            >
              Contact Us
            </button>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default LandlordPaymentFailView;
